import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'
import { IWindow } from 'static/interfaces'
import { IBuildedTourGroup } from 'utils/weeklyTypes'
import { Tooltip } from 'components/atoms/Tooltip'
import { ConnectTodoModalBody } from './ConnectTodoModalBody'
import { useWeeklyContext } from 'core/contexts/weekly/WeeklyContext'
import { StaticContext } from 'core/contexts/weekly/StaticContext'
import SvgIcon from 'components/atoms/SvgIcon'

declare var window: IWindow

export const ConnectTodoIcons = (props: IBuildedTourGroup) => {
  const { getMeetupPlaces, getConnectionMailTemplates } = React.useContext(StaticContext)
  const { selectedTour, onTourUpdate } = useWeeklyContext()

  const unDoneTasks = React.useMemo(() => {
    return props.tasks?.filter(todo => !todo.done) ?? []
  }, [props.tasks])
  const showConnectTodoModal = React.useCallback(
    e => {
      e.stopPropagation()
      window.globalModal.showModal({
        title: 'プライベートツアーのステータス',
        body: (
          <ConnectTodoModalBody
            {...props}
            selectedTour={selectedTour}
            onTourUpdate={onTourUpdate}
            meetupPlaces={getMeetupPlaces()}
            connectionMailTemplates={getConnectionMailTemplates()}
          />
        ),
      })
    },
    [props, selectedTour, onTourUpdate]
  )

  return (
    <ConnectTodoIconWrapper>
      {unDoneTasks.length < 3 && (
        <SvgIcon
          name="add_circle"
          className="addIcon"
          ariaHidden={true}
          role="button"
          onClick={showConnectTodoModal}
        />
      )}
      {unDoneTasks.map(({ id, label, className }) => {
        return label === '他' ? (
          <Tooltip content={props.internal_memo ?? 'メモ記載なし'} key={id} position="left">
            <div className={`todoIcon ${className}`} onClick={showConnectTodoModal} role="button">
              {label}
            </div>
          </Tooltip>
        ) : (
          <div
            key={id}
            className={`todoIcon ${className}`}
            onClick={showConnectTodoModal}
            role="button"
          >
            {label}
          </div>
        )
      })}
    </ConnectTodoIconWrapper>
  )
}

const ConnectTodoIconWrapper = styled.div`
  display: flex;
  color: ${constants.COLORS.subText};
  gap: 8px;
  margin-right: 8px;
  .addIcon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: color 0.2s;
    &:hover {
      color: ${constants.COLORS.primary};
    }
  }

  .todoIcon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-weight: 600;
    color: ${constants.COLORS.black};
    border: 1px solid ${constants.COLORS.white};
    cursor: pointer;
    transition: border-color 0.2s;

    &.checkEmail {
      background-color: ${constants.COLORS.dangerBG};
    }
    &.checkHotel {
      background-color: #e5f3f0;
    }
    &.other {
      background-color: #dcdee4;
    }
    &:hover {
      border-color: ${constants.COLORS.primary};
    }
  }
`
